import "core-js/modules/es6.function.name";

/*
 * @Descripttion: file content
 * @Author: zc
 * @Date: 2020-05-26 13:24:22
 * @LastEditors: zc
 * @LastEditTime: 2020-11-23 12:54:31
 */
import { getToken, setToken as _setToken, removeToken as _removeToken } from '@/utils/auth';
var state = {
  token: getToken(),
  name: '',
  userAlert: {
    flag: false,
    type: '',
    text: '',
    imgUrl: '',
    callBack: ''
  }
};
var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_USER_VO: function SET_USER_VO(state, res) {
    state.userVo = JSON.stringify(res);
    window.localStorage.setItem('userInfo', JSON.stringify(res));
  },
  USER_ALERT: function USER_ALERT(state, res) {
    if (Array.isArray(res)) {
      // 根据传值类型不同改变不同数据
      state.userAlert[res[0]] = res[1];
    } else {
      for (var i in res) {
        state.userAlert[i] = res[i];
      }
    }
  }
};
var getters = {
  token: function token(state) {
    return state.token;
  },
  name: function name(state) {
    return state.name;
  },
  userVo: function userVo(state) {
    return state.userVo;
  },
  userAlerts: function userAlerts(state) {
    return state.userAlert;
  }
};
var actions = {
  setToken: function setToken(_ref, token) {
    var commit = _ref.commit;

    _setToken(token);

    commit('SET_TOKEN', token);
  },
  removeToken: function removeToken(_ref2) {
    var commit = _ref2.commit;

    _removeToken();

    commit('SET_TOKEN', '');
  },
  setUserVo: function setUserVo(_ref3, res) {
    var commit = _ref3.commit;
    commit('SET_USER_VO', res);
  },
  setUserAlert: function setUserAlert(_ref4, res) {
    var commit = _ref4.commit;
    commit('USER_ALERT', res);
  }
};
export default {
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations,
  namespaced: true
};